<template>
  <div>
    <h1>
      {{ $t('message.login.loginQrBindHead') }}
    </h1>
    <div class="mt-12" v-html="$t('message.login.loginQrBindBody')" />
    <div class="mb-6">
      <qrcode-vue size="200" :value="bindQrCode" class="my-6"/>
      <vs-button @click="next" type="filled">
        {{ $t('message.login.setAuthButton') }}
      </vs-button>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LoginBindQr',
  methods: {
    ...mapActions('user', ['getBindQrCode', 'setBindQrCode']),
    async next () {
      try {
        await this.setBindQrCode()
        this.$emit('downloaded')
      } catch (e) {
        console.log(e)
      }
    }
  },
  computed: {
    ...mapGetters('user', ['bindQrCode'])
  },
  mounted () {
    this.getBindQrCode()
  },
  components: {
    QrcodeVue
  }
}
</script>

<style scoped>

</style>
